import { CREHANA_BASE_URL_PRD } from '@crehana/constants';
import { AuthUserRoleEnum } from "../generated/graphql/types";
export var redirectToTalent = function redirectToTalent(options) {
  var centralizedId = options.centralizedId,
    userRole = options.userRole,
    url = options.url;
  var parsedUrl = new URL(url);
  var nextUrl = parsedUrl.searchParams.get('next');
  window.location.href = "/api/v5/rest/auth/learning/auth/cross/talent/?centralized_organization_id=".concat(centralizedId, "&user_role=").concat(userRole, "&next_url=").concat(nextUrl);
};
export var handleNavigation = function handleNavigation(_ref) {
  var url = _ref.url,
    centralizedId = _ref.centralizedId,
    userRole = _ref.userRole,
    onClickItem = _ref.onClickItem,
    openInNewTab = _ref.openInNewTab;
  // these urls are from new microfrontends like the talent or learning
  // for them we are using full url including https
  if (url !== null && url !== void 0 && url.startsWith("".concat(CREHANA_BASE_URL_PRD, "/")) || url !== null && url !== void 0 && url.startsWith('https://crehana.com/') || url !== null && url !== void 0 && url.startsWith('https://ayuda.crehana.com')) {
    window.location.href = url;
    return;
  }

  // if the urls doesn't start with the crehana's domains then it means they are talent urls that includes https and query params for cross product authentication
  if (url !== null && url !== void 0 && url.includes('https://')) {
    redirectToTalent({
      centralizedId: centralizedId || '',
      // Fallback AuthRoleUser every user has collaborator role
      userRole: userRole || AuthUserRoleEnum.AuthRoleUser,
      url: url || ''
    });
  } else {
    onClickItem(url || '', openInNewTab);
  }
};